import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions } from '../../../redux/modules/reports/maintenance_dob/targetedMonthlyVisitsReportActions'
import { Button, Form, AutoComplete, Input, Icon, Spin } from 'antd'
import _ from 'lodash'
import { convertToOption } from '../../../util'
import ListItems from '../../../components/reports/maintenance_dob/targeted-monthly-visits/ListItem'
import queryString from 'qs'
import config from '../../../config'

const { API_BASE } = config

const propTypes = {}
const FormItem = Form.Item

class TargetedMonthlyVisitsReportContainer extends Component {
  constructor(props) {
    super(props)

    const filter = []

    this.state = {
      filter
    }

    // get job list
    this.props.targetedMonthlyVisitsReportGetJobList({})
  }

  applyFilter = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      this.props.targetedMonthlyVisitsReportGetFullReport({ filters: values })
    })
  }

  handleJobSearch = _.debounce(value => {
    this.props.targetedMonthlyVisitsReportGetJobList({
      filters: {
        name: value
      }
    })
  }, 500)

  printReport = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      const params = _.omit(values, 'date_range')

      const qs = queryString.stringify(params)
      const url = `${API_BASE}/api/reports/maintenance-dob/targeted-monthly-visits-report/print?${
        qs
      }`
      window.open(url, '_blank')
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    const jobListData = _.get(this.props, 'targetedMonthlyVisitsReportActions.jobList.data')
    const loadingJobList = _.get(this.props, 'targetedMonthlyVisitsReportActions.loadingJobList')

    const loadingFullReport = _.get(
      this.props,
      'targetedMonthlyVisitsReportActions.loadingFullReport'
    )
    const fullReport = _.get(this.props, 'targetedMonthlyVisitsReportActions.fullReport.data')
    return (
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        <div className="row">
          <div className="col-10">
            <h3>Targeted Monthly Visits</h3>
          </div>
          <Button icon="printer" onClick={() => this.printReport()} />
        </div>
        <Form layout="vertical">
          <div className="row">
            <div className="col-4">
              <div className="row">
                <div className="col-10">
                  <Spin spinning={loadingJobList}>
                    <FormItem label="Job">
                      {getFieldDecorator('job_id', {})(
                        <AutoComplete
                          onChange={this.handleJobSearch}
                          dataSource={convertToOption(jobListData)}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          placeholder="Search for a Job"
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  </Spin>
                </div>
              </div>
            </div>
          </div>
          <Button type="primary" onClick={() => this.applyFilter()}>
            Submit
          </Button>
        </Form>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-12">
            <ListItems fullReport={fullReport} loadingFullReport={loadingFullReport} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ targetedMonthlyVisitsReportActions, authentication }, ownProps) => ({
  targetedMonthlyVisitsReportActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions), dispatch)
})

TargetedMonthlyVisitsReportContainer.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(TargetedMonthlyVisitsReportContainer))
)



// WEBPACK FOOTER //
// ./src/containers/reports/maintenance_dob/TargetedMonthlyVisitsReportContainer.js